
import { useMemo } from 'react'
import AxisBottomText from '../../../components/Graphs/BarGroup/AxisBottomText'
import { longNumberFormt } from '../../../utils/tools'
import BarGroupGraph from '../../../components/Graphs/BarGroup/BarGroupGraph'
import styles from './ReportGraph.module.scss'
import useReportGroupBar from '../hooks/useReportGroupBar'

const ReportPageGraph = ({graphs}) => {
    const xKey = 'date'
    const { keys, barGroupFormatGraphs } = useReportGroupBar(graphs)

    const CastumeAxisBottom = (props) => {
        const shortMonth = new Date(props.value).toLocaleString('default', { month: 'short' })
        const year = new Date(props.value).getFullYear().toString().substring(2)
        return <AxisBottomText extraClassname={styles['bar-group-axis']} {...props} key={props.value} value={`${shortMonth} ${year}`}/>
    }

    const colors = useMemo(() => graphs?.map(({color}) => color), [graphs])
    
    const CastumeAxisLeft = (props) => <AxisBottomText extraClassname={styles['bar-group-axis']} {...props} key={props.value} value={longNumberFormt(props.value)}/>
    
    const formatValue = (value) => longNumberFormt(value)

    return (
        <BarGroupGraph 
            showValueOnHover 
            formatValue={formatValue} 
            data={barGroupFormatGraphs} 
            colors={colors} 
            keys={keys} 
            xKey={xKey}
            CastumeAxisBottom={CastumeAxisBottom} 
            CastumeAxisLeft={CastumeAxisLeft} 
            showAxisLeft  
            margin={{top:10, right:0, bottom:15, left:20 }}/>
    )          
}

export default ReportPageGraph